"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleBoxSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _styles = require("../styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ArticleBoxSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.Root, {
    className: className,
    "data-testid": getTestId(_constants.ARTICLE_BOX_SKELETON),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.ImageSkeleton, {
      variant: "rectangular",
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.CategorySkeleton, {
      variant: "rectangular",
      animation: animation
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.TitleContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnifiedSkeleton, {
        variant: "rectangular",
        width: "70%",
        height: "2rem",
        animation: animation
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnifiedSkeleton, {
        variant: "rectangular",
        width: "50%",
        height: "2rem",
        animation: animation
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles2.IntroContainer, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnifiedSkeleton, {
        variant: "rectangular",
        width: "70%",
        height: "1.4rem",
        animation: animation
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnifiedSkeleton, {
        variant: "rectangular",
        width: "100%",
        height: "1.4rem",
        animation: animation
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.UnifiedSkeleton, {
      variant: "rectangular",
      width: "64px",
      height: "1.9rem",
      animation: animation
    })]
  });
};
exports.ArticleBoxSkeleton = ArticleBoxSkeleton;
//# sourceMappingURL=ArticleBoxSkeleton.js.map